/**
 * Aba Configurações: canal de envio e limites anti-banimento.
 */
import React from 'react';
import { Button } from '../../../../components/ui/Button';
import Spinner from '../../../../components/ui/Spinner';
import { useOrganization } from '../../../../contexts/OrganizationContext';
import { useWhatsAppConnections } from '../../auto-movement/hooks/useWhatsAppConnections';
import { useFollowUpSettings } from '../hooks/useFollowUpSettings';
import FollowUpAntiBanFields from './FollowUpAntiBanFields';
import FollowUpChannelFields from './FollowUpChannelFields';

export default function FollowUpParamsTab() {
    const { currentOrganization } = useOrganization();
    const { connections, loading: loadingConnections } = useWhatsAppConnections(currentOrganization?.id);
    const {
        backupConnectionIds,
        addBackupConnection,
        removeBackupConnection,
        minIntervalSeconds,
        setMinIntervalSeconds,
        maxSendsPerCycle,
        setMaxSendsPerCycle,
        pauseTimeoutHours,
        setPauseTimeoutHours,
        loading,
        saving,
        loadError,
        canSave,
        save,
        reload,
    } = useFollowUpSettings();

    if (loading) {
        return (
            <section
                className="flex min-h-40 items-center justify-center py-s8"
                aria-busy="true"
                aria-label="Configurações de follow-up"
            >
                <Spinner size="lg" color="primary" />
            </section>
        );
    }

    if (loadError) {
        return (
            <section aria-label="Configurações de follow-up">
                <div
                    className="flex flex-col gap-s3 rounded-xl border border-error/30 bg-danger-bg px-s4 py-s3"
                    role="alert"
                >
                    <p className="text-sm text-error">{loadError}</p>
                    <Button type="button" variant="secondary" onClick={reload} className="self-start">
                        Tentar novamente
                    </Button>
                </div>
            </section>
        );
    }

    return (
        <section className="flex flex-col gap-s5" aria-label="Configurações de follow-up">
            <FollowUpChannelFields
                connections={connections}
                loadingConnections={loadingConnections}
                backupConnectionIds={backupConnectionIds}
                onAdd={addBackupConnection}
                onRemove={removeBackupConnection}
            />
            <FollowUpAntiBanFields
                minIntervalSeconds={minIntervalSeconds}
                onMinIntervalSecondsChange={setMinIntervalSeconds}
                maxSendsPerCycle={maxSendsPerCycle}
                onMaxSendsPerCycleChange={setMaxSendsPerCycle}
                pauseTimeoutHours={pauseTimeoutHours}
                onPauseTimeoutHoursChange={setPauseTimeoutHours}
            />
            <footer className="flex flex-col-reverse gap-s2 sm:flex-row sm:justify-end sm:gap-s3">
                <Button
                    type="button"
                    onClick={save}
                    disabled={!canSave || saving}
                    className="min-h-11 w-full touch-manipulation sm:w-auto md:min-h-9"
                >
                    {saving ? (
                        <>
                            <Spinner size="sm" color="white" />
                            Salvando...
                        </>
                    ) : (
                        'Salvar'
                    )}
                </Button>
            </footer>
        </section>
    );
}
